export enum Classification {
  Dicom = 'dicom',
  Pathology = 'pathology',
  Ekg = 'ekg',
  Attachment = 'attachment',
  Document = 'document',
  /** Files that can be anything (DICOM, EKG, text, whatever).  These files do not get parsed or compressed.  They simply get bulk uploaded for manual retrieval by CompuMed Support. */
  Alternative = 'alternative',
}
